import React, { useEffect, useState } from "react";
import * as Constants from "../../../../constants";
import { IParams } from "../../../../models/card";
import {
  ICoreModifiers,
  IModifierGroups,
  IRequiredModifiersGroupsModifiers,
} from "../../../../models/item.model";
import { IBucketSelectedIngredients } from "../../../../models/try2Combo";
import { itemBuckets } from "../../../../priceCalculation/buckets";
import { ADDITIONAL_ADDED } from "../../../../priceCalculation/constants";
import { filterArraysBasedOnGroupId } from "../../../../helpers/customizedItem/customizedItem.helper";
import ItemModifierGroups from "../../../../containers/try2/Customization/try2Customization/ingredients/ModifierGroups/ItemModifierGroups";
import styles from "./UpSellModifierGroup.module.scss";
import CoreModifiersCards from "../CoreModifiersCards";
import { REACT_APP_PROTEIN_GROUPS, REACT_APP_BOWLS_ID, REACT_APP_SALADS_ID } from "../../../../constants";
import useCheckMobileScreen from "../../../../hooks/useCheckMobileScreen";

type IUpSellModifierGroup = {
  coreModifiers: ICoreModifiers[];
  modifierGroups: IModifierGroups[];
  handleIngredientSelection: (data: any) => void;
  required_modifiers_groups: IRequiredModifiersGroupsModifiers[];
  category_name: string;
  category_id: string;
  isSaladFirstSelection?: boolean;
  try2comboUpsellStyles?: string;
  HeadingStyles?: boolean;
  setDoubleProteinModalVisible?:(state) => void;
  setAddProteinModalVisible?:(state) => void;
};

type AllowedModifierType =
  | typeof Constants.CORE_MODIFIERS
  | typeof Constants.ADD_ONS;

type ModifierGroupType = {
  type: AllowedModifierType;
  modifiers: ICoreModifiers[] | IModifierGroups | any;
  coreModifierslength?: number;
};
const proteinGroup = JSON.parse(REACT_APP_PROTEIN_GROUPS);

const UpSellModifierGroup: React.FC<IUpSellModifierGroup> = (props) => {
  const {
    coreModifiers,
    handleIngredientSelection,
    modifierGroups,
    category_name,
    category_id,
    required_modifiers_groups,
    isSaladFirstSelection,
    try2comboUpsellStyles,
    HeadingStyles,
    setDoubleProteinModalVisible,
    setAddProteinModalVisible
  } = props;
  const [showGroup, setShowGroup] = useState<ModifierGroupType>();
  const isThisMobile = useCheckMobileScreen();

  const [label, setLabel] = useState<string>();

  useEffect(() => {
    let currentShowGroup: ModifierGroupType | any = {};
    const isProtienExistAsRequired = required_modifiers_groups.find(
      (modifierGroup: IRequiredModifiersGroupsModifiers) =>
        proteinGroup.includes(modifierGroup.id)
    );
    /*
      @param(modifier_group_id as modifier_group_id)
      Checking Protien Existance In Core Modifiers 
    */
    if (coreModifiers?.length > 0) {
      const modifiers = coreModifiers.filter((modifier: ICoreModifiers) =>
        proteinGroup.includes(modifier.modifier_group_id)
      );
      currentShowGroup = {
        type: Constants.CORE_MODIFIERS,
        modifiers,
        coreModifierslength: modifiers.length,
      };
    }
    /*
      @param(modifier_group_id as modifier_group_id)
      Checking Protien Existance In ADDONS Modifiers 
    */
    if (
      modifierGroups?.length > 0 &&
      currentShowGroup.coreModifierslength <= 0 &&
      !isProtienExistAsRequired
    ) {
      const modifierGroup = modifierGroups.find((modifier: IModifierGroups) =>
        proteinGroup.includes(modifier.id)
      );
      currentShowGroup = {
        type: Constants.ADD_ONS,
        modifiers: modifierGroup,
      };
    }
    setShowGroup(currentShowGroup);
    if (setDoubleProteinModalVisible &&
      currentShowGroup?.type === Constants.CORE_MODIFIERS &&
      currentShowGroup.coreModifierslength > 0
    ) {
      setDoubleProteinModalVisible(true);
    }

    if (setAddProteinModalVisible &&
      currentShowGroup?.type === Constants.ADD_ONS &&
      currentShowGroup.modifiers
    ) {
      setAddProteinModalVisible(true);
    }
  }, [coreModifiers, modifierGroups, required_modifiers_groups]);

  useEffect(() => {
if (category_id?.toString() === REACT_APP_SALADS_ID || category_id?.toString() === REACT_APP_BOWLS_ID) {
      setLabel(
        showGroup?.type === Constants.CORE_MODIFIERS
          ? Constants.DOUBLE_YOUR_PROTEIN
          : Constants.ADD_PROTEIN
      );
    }
  }, [category_name, required_modifiers_groups, showGroup]);

  const coreModifierBucket = (function () {
    return itemBuckets.getSingleBucket({
      name: Constants.CORE_MODIFIERS,
      fromItem: isSaladFirstSelection
        ? Constants.TRY_TO_COMBO_SELECTED_SECTION
        : Constants.SINGLE_ITEM_SELECTED_SECTION,
    });
  })();
  const isItCoreRelated = (groupId: number) => {
    if (coreModifierBucket["memoryChip"]) {
      const isExist = coreModifierBucket["memoryChip"][groupId];
      if (isExist === undefined) {
        return false;
      } else {
        return true;
      }
    }
  };

  const selectedAddedAddOns: IBucketSelectedIngredients[] = (function () {
    const fromItem: any =
      (isSaladFirstSelection
        ? Constants.TRY_TO_COMBO_SELECTED_SECTION
        : Constants.SINGLE_ITEM_SELECTED_SECTION) - 1;
    return itemBuckets.getSingleBucketKeyValue({
      name: Constants.ADD_ONS,
      fromItem,
      modifierType: ADDITIONAL_ADDED,
      key: "modifiers",
    });
  })();
  

  const isLimitExceed = (
    groupId: number,
    extendable_limit: number,
    groupMin
  ) => {
    if (extendable_limit === 1 && groupMin === 1) {
      return false;
    } else {
      if (!isItCoreRelated(groupId)) {
        const selectedModifierForCurrentGroup = filterArraysBasedOnGroupId(
          [selectedAddedAddOns],
          groupId
        );
        return selectedModifierForCurrentGroup.length >= extendable_limit
          ? true
          : false;
      } else {
        if (coreModifierBucket["memoryChip"][groupId]?.changes) {
          return coreModifierBucket["memoryChip"][groupId]?.changes?.quantity >=
            extendable_limit
            ? true
            : false;
        } else {
          return coreModifierBucket["memoryChip"][groupId]?.quantity >=
            extendable_limit
            ? true
            : false;
        }
      }
    }
  };

  const selectedCore: IBucketSelectedIngredients[] = (function () {
    return itemBuckets.specificItemBucketSelectedModifiers(
      Constants.CORE_MODIFIERS,
      isSaladFirstSelection
        ? Constants.TRY_TO_COMBO_SELECTED_SECTION
        : Constants.SINGLE_ITEM_SELECTED_SECTION
    );
  })();

  const handleCoreModifierClick = (
    data: IParams,
    modifier: ICoreModifiers,
    type: string
  ) => {
    handleIngredientSelection({
      ...data,
      ...{
        modifier_group_id: modifier?.modifier_group_id,
        modifier_type: type,
      },
    });
  };

  const selectedAddOns = (function () {
    return itemBuckets.specificItemBucketSelectedModifiers(
      Constants.ADD_ONS,
      isSaladFirstSelection
        ? Constants.TRY_TO_COMBO_SELECTED_SECTION
        : Constants.SINGLE_ITEM_SELECTED_SECTION
    );
  })();

  const handleClick = (
    data: IParams,
    modifierGroup: IModifierGroups,
    type: string
  ) => {
    handleIngredientSelection({
      ...data,
      ...{
        modifier_group_id: modifierGroup?.id,
        modifier_group_max: modifierGroup?.max,
        modifier_group_base: modifierGroup?.base,
        modifier_type: type,
      },
    });
  };

  return (
    <>
      {showGroup?.type === Constants.CORE_MODIFIERS &&
        showGroup.coreModifierslength > 0 && (
          <div>
            <h5
              className={`${
                HeadingStyles
                  ? "visby-cf f-s22 f-sm-s16 text-start text-capitalize"
                  : "f-s20 f-sm-s18 text-capitalize lh-normal font-Cls text-start pt-2 pt-md-3 "
              }`}
              id="double-your-protien-modal"
            >
              {label}
            </h5>
            <div
              className={`${styles.upselModifiers} ${try2comboUpsellStyles}`}
            >
              <CoreModifiersCards
                coreModifiers={showGroup.modifiers}
                selectedCore={selectedCore}
                handleCoreModifierClick={handleCoreModifierClick}
                isLimitExceed={isLimitExceed}
                upsellStylesClass={styles.upsellStylesClass}
                upsellCardPadding={styles.cardPadding}
              />
            </div>
          </div>
        )}
      {showGroup?.type === Constants.ADD_ONS && showGroup.modifiers && (
        <div>
          <h5
            className={`${
              HeadingStyles
                ? "visby-cf f-s22 f-sm-s16 text-start text-capitalize"
                : "f-s20 f-sm-s18 text-capitalize lh-normal font-Cls text-start pt-2 pt-md-3"
            } `}
            id="add-your-protien-modal"
          >
            {label}
          </h5>
          <div className={`${styles.upselModifiers} ${try2comboUpsellStyles}`}>
            <ItemModifierGroups
              ingredients={showGroup.modifiers}
              selectedAddOns={selectedAddOns}
              selectedCore={selectedCore}
              handleClick={handleClick}
              isLimitExceed={isLimitExceed}
              upsellStylesClass={styles.upsellStylesClass}
              noGrid={true}
              upsellCardPadding={styles.cardPadding}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default UpSellModifierGroup;
